import {createReducer} from 'redux-act';
import * as actions from './actions';

const initialState = {
	defaultLocationConfigShown: false,
};

export const uiReducer = createReducer({}, initialState);

uiReducer
	//
	.on(actions.setDefaultLocationConfigShown, (state, defaultLocationConfigShown) => ({
		...state,
		defaultLocationConfigShown,
	}));
